document.addEventListener('DOMContentLoaded', function() {
    // Trova tutti gli accordion
    var accordionDetails = document.querySelectorAll('.accordion.accordion--lg details');
    
    // Forza l'apertura iniziale di tutti gli accordion
    accordionDetails.forEach(function(detail) {
        if (!detail.hasAttribute('open')) {
            detail.setAttribute('open', ''); // Forza l'apertura dell'accordion al caricamento
        }
    });

    // Gestisci il clic per aprire e chiudere l'accordion
    accordionDetails.forEach(function(detail) {
        detail.addEventListener('click', function() {
            // Il sistema gestirà automaticamente il simbolo da "+" a "-" senza bisogno di ulteriori modifiche
        });
    });
});
